/*
 * @Author: wyh
 * @Date: 2019-07-04 17:55:34
 * @Last Modified by: wyh
 * @Last Modified time: 2019-07-04 18:08:30
 * @Description: 汉字转拼音
 */
import { Injectable } from "@angular/core";
import "rxjs/add/operator/map";
import { PINYIN } from "./city.pinyin";
import { FirstPINYIN, oMultiDiff } from "./city.pinyin";

@Injectable()
export class PinYinProvider {
  private headers = new Headers({ "Content-Type": "application/json" });
  PinYin: any = PINYIN;

  constructor() {}

  public codefans_net_CC2PY(l1) {
    var l2 = l1.length;
    var I1 = "";
    var reg = new RegExp("[a-zA-Z0-9- ]");
    for (var i = 0; i < l2; i++) {
      var val = l1.substr(i, 1);
      var name = this.arraySearch(val, this.PinYin);
      if (reg.test(val)) {
        I1 += val;
      } else if (name !== false) {
        I1 += name;
      }
    }
    I1 = I1.replace(/ /g, "-");
    while (I1.indexOf("--") > 0) {
      I1 = I1.replace("--", "-");
    }
    return I1;
  }

  private arraySearch(l1, l2) {
    for (var name in this.PinYin) {
      if (this.PinYin[name].indexOf(l1) != -1) {
        return this.ucfirst(name);
      }
    }
    return false;
  }

  private ucfirst(l1) {
    if (l1.length > 0) {
      var first = l1.substr(0, 1).toUpperCase();
      var spare = l1.substr(1, l1.length);
      return first + spare;
    }
  }

  //此处收录了375个多音字
  //参数,中文字符串
  //返回值:拼音首字母串数组
  makePy(str) {
    if (typeof str != "string") var arrResult = new Array(); //保存中间结果的数组
    for (var i = 0, len = str.length; i < len; i++) {
      //获得unicode码
      var ch = str.charAt(i);
      //检查该unicode码是否在处理范围之内,在则返回该码对映汉字的拼音首字母,不在则调用其它函数处理
      arrResult.push(this.checkCh(ch));
    }
    //处理arrResult,返回所有可能的拼音首字母串数组
    return this.mkRslt(arrResult);
  }

  checkCh(ch) {
    var uni = ch.charCodeAt(0);
    //如果不在汉字处理范围之内,返回原字符,也可以调用自己的处理函数
    if (uni > 40869 || uni < 19968) return ch; //dealWithOthers(ch);
    //检查是否是多音字,是按多音字处理,不是就直接在strChineseFirstPY字符串中找对应的首字母
    return oMultiDiff[uni] ? oMultiDiff[uni] : FirstPINYIN.charAt(uni - 19968);
  }
  mkRslt(arr) {
    var arrRslt = [""];
    for (var i = 0, len = arr.length; i < len; i++) {
      var str = arr[i];
      var strlen = str.length;
      if (strlen == 1) {
        for (var k = 0; k < arrRslt.length; k++) {
          arrRslt[k] += str;
        }
      } else {
        var tmpArr = arrRslt.slice(0);
        arrRslt = [];
        for (k = 0; k < strlen; k++) {
          //复制一个相同的arrRslt
          var tmp = tmpArr.slice(0);
          //把当前字符str[k]添加到每个元素末尾
          for (var j = 0; j < tmp.length; j++) {
            tmp[j] += str.charAt(k);
          }
          //把复制并修改后的数组连接到arrRslt上
          arrRslt = arrRslt.concat(tmp);
        }
      }
    }
    return arrRslt;
  }
  // //两端去空格函数
  // String.prototype.trim = function () { return this.replace(/(^\s*)|(\s*$)/g, ""); }
  // //查看拼音首字母缩写
  // function query() {
  //     var str = document.getElementById("txtChinese").value.trim();
  //     if (str == "") return;
  //     var arrRslt = makePy(str);
  //     alert(arrRslt);
  // }
}



// WEBPACK FOOTER //
// ./src/services/common/city/city.pinyin.service.ts